import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const PersonalInformations = loadable(() => pMinDelay(import('./PersonalInformations'), 300), {
  fallback: <Loading />
});

const MembershipInformations = loadable(() => pMinDelay(import('./MembershipInformations'), 300), {
  fallback: <Loading />
});

const GiftInformations = loadable(() => pMinDelay(import('./GiftInformations'), 300), {
  fallback: <Loading />
});

const MailAdress = loadable(() => pMinDelay(import('./MailAdress'), 300), {
  fallback: <Loading />
});

const PhoneNumber = loadable(() => pMinDelay(import('./PhoneNumber'), 300), {
  fallback: <Loading />
});

const AsyncPersonalInformations = props => {
  const { linkName } = props.match.params;

  let pageContent;
  let pageConfig = {
    headerType: 'full',
    footerType: 'full',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-white hide-betslip hide-sticky-navigation`
      },
      title: 'Bilyoner.com | Hesabım | Kişisel Bilgilerim'
    }
  };

  switch (linkName) {
    case 'uyelik-bilgilerim':
      pageContent = <MembershipInformations { ...props }/>;
      pageConfig.helmet.title = 'Bilyoner.com | Hesabım | Üyelik Bilgilerim';
      break;
    case 'hediye-bilgilerim':
      pageContent = <GiftInformations { ...props }/>;
      pageConfig.helmet.title = 'Bilyoner.com | Hesabım | Hediye Bilgilerim';
      break;
    case 'cep-telefonum':
      pageContent = <PhoneNumber { ...props }/>;
      pageConfig.helmet.title = 'Bilyoner.com | Hesabım | Cep Telefonu';
      break;
    case 'e-posta-adresim':
      pageContent = <MailAdress { ...props }/>;
      pageConfig.helmet.title = 'Bilyoner.com | Hesabım | E-Posta Adresi';
      break;
    default:
      pageContent = <PersonalInformations { ...props }/>;
  }

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      { pageContent }
    </ApplicationLayout>
  );
};

AsyncPersonalInformations.propTypes = {
  userAgent: PropTypes.object,
  match: PropTypes.object
};

export default AsyncPersonalInformations;
